import { apiFetch } from './api-fetch'

export type PayoutReportSyncStatus = 'queued' | 'running' | 'downloaded' | 'failed'

export interface PayoutReportSyncResult {
  status: PayoutReportSyncStatus
  settlementCount: number
}

type PayoutReportFetcher = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>

/** Typed browser boundary for the single host-owned payout lifecycle step. */
export async function requestPayoutReportSync(
  fetcher: PayoutReportFetcher = apiFetch,
): Promise<PayoutReportSyncResult> {
  const response = await fetcher('/api/analytics/payouts/sync', { method: 'POST' })
  const payload = await response.json() as {
    status?: unknown
    settlementCount?: unknown
    error?: unknown
    detail?: unknown
  }
  if (!response.ok) {
    const message = typeof payload.error === 'string'
      ? payload.error
      : typeof payload.detail === 'string'
        ? payload.detail
        : 'Не удалось обновить выплаты'
    throw new Error(message)
  }
  if (
    !['queued', 'running', 'downloaded', 'failed'].includes(String(payload.status))
    || !Number.isInteger(payload.settlementCount)
    || Number(payload.settlementCount) < 0
  ) {
    throw new Error('Сервер вернул некорректное состояние финансового отчёта.')
  }
  return {
    status: payload.status as PayoutReportSyncStatus,
    settlementCount: Number(payload.settlementCount),
  }
}
